export const FearlessWallet = () => (
  <svg
    viewBox="0 0 256 256"
    fill="none"
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_101_12060)">
      <rect width="256" height="256" rx="128" fill="#F40169" />
      <g filter="url(#filter0_f_101_12060)">
        <path
          d="M228.409 140.629l-42.486 18.613c-1.433.628-2.15.942-2.729 1.449-.58.506-.987 1.175-1.8 2.511l-16.407 26.954c-.252.414-.378.621-.523.814-.145.193-.308.372-.634.73l-45.07 49.362c-.327.358-.49.536-.635.73-.145.193-.271.4-.523.813l-13.532 22.233c-2.152 3.535-3.229 5.303-2.916 7.145.313 1.841 1.912 3.154 5.11 5.782l28.391 23.32c.995.818 1.493 1.227 2.071 1.495.579.268 1.212.384 2.48.615l49.615 9.057c1.727.315 2.59.473 3.439.336.85-.138 1.62-.559 3.159-1.402l33.992-18.615 52.954-38.665c1.337-.976 2.006-1.464 2.476-2.127.471-.662.712-1.454 1.194-3.038l17.578-57.757 8.907-48.774c.184-1.006.276-1.509.265-2.017-.012-.508-.125-1.007-.353-2.004l-5.874-25.731c-1.35-5.919-2.026-8.878-4.296-9.899-2.269-1.021-4.932.437-10.256 3.353l-6.28 3.439a9.943 9.943 0 01-.669.35c-.172.078-.35.143-.705.273l-25.789 9.415c-.662.241-.993.362-1.303.528-.31.165-.595.373-1.164.789l-25.803 18.84c-.441.322-.661.483-.897.619-.236.135-.487.245-.987.464z"
          fill="#16002C"
          fillOpacity=".59"
        />
      </g>
      <path
        d="M246.104 101.795l-93.476 12.971a2.397 2.397 0 00-1.41.732l-7.695 8.077a2.364 2.364 0 01-3.464 0l-1.347-1.415c-.967-1.014-.967-2.666 0-3.68l9.185-9.64c.967-1.014.967-2.665 0-3.679L129.73 86.089a2.364 2.364 0 00-3.464 0l-18.167 19.072c-.967 1.014-.967 2.665 0 3.679l9.185 9.64c.967 1.014.967 2.666 0 3.68l-1.347 1.415a2.364 2.364 0 01-3.464 0l-7.695-8.077a2.411 2.411 0 00-1.41-.732L9.894 101.795c-2.33-.324-3.717 2.662-2.05 4.412l20.384 21.399c1.554 1.63.46 4.433-1.73 4.433s-3.284 2.803-1.73 4.433l19.107 20.058c.313.327.707.563 1.133.676l65.041 17.217c.527.14.997.461 1.334.912l10.062 13.498c1.793 2.616 4.824 5.644 4.824 5.644a2.364 2.364 0 003.464 0s2.507-2.676 4.824-5.644l10.063-13.498a2.443 2.443 0 011.333-.912l65.041-17.217c.43-.113.82-.349 1.133-.676l19.108-20.058c1.553-1.63.46-4.433-1.731-4.433-2.19 0-3.284-2.803-1.73-4.433l20.384-21.399c1.664-1.75.277-4.732-2.054-4.412z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="clip0_101_12060">
        <rect width="256" height="256" rx="128" fill="#fff" />
      </clipPath>
      <filter
        id="filter0_f_101_12060"
        x="18.601"
        y="19.734"
        width="376.685"
        height="375.403"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          stdDeviation="41.25"
          result="effect1_foregroundBlur_101_12060"
        />
      </filter>
    </defs>
  </svg>
);

export default FearlessWallet;
